/* eslint react/prefer-stateless-function: 0 */

import React from 'react';
import PropTypes from 'prop-types';
import ReactRouterPropTypes from 'react-router-prop-types';
import {
  View,
  ScrollView,
} from 'react-native';

import { translate } from '../../locales/i18n';
import styles from '../../styles';
import AORTypes from '../../types';
import methods from '../../modules/payout';
import Header from '../../components/misc/Header';

class PublisherMethod extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.dismissConfigure = this.dismissConfigure.bind(this);
    this.selectConfigure = this.selectConfigure.bind(this);

    // eslint-disable-next-line react/no-unused-class-component-methods
    this.displayName = 'PublisherMethod';
  }

  dismissConfigure() {
    const { history } = this.props;

    history.push('/publishersettings');
  }

  selectConfigure(methodSettings) {
    const {
      history,
      userData,
      onUpdateUser,
      updateUserData,
    } = this.props;

    console.log('before');
    console.log(userData);
    console.log(methodSettings);
    Object.assign(userData, methodSettings);
    console.log('after');
    console.log(userData);

    onUpdateUser(userData)
      .then(() => {
        updateUserData()
          .then((_result) => {
            history.push('/publishersettings');
          });
      });
  }

  render() {
    const { userData, history, match: { params: { method } } } = this.props;

    if (!userData) {
      console.log('no userData');

      return (
        <>
        </>
      );
    }

    const CustomComponent = methods[method].configure(this.dismissConfigure, this.selectConfigure);

    return (
      <View
        style={styles.view.headed}
      >
        <Header
          name={translate(methods[method].name)}
          hasBack
          history={history}
        />

        <ScrollView
          style={{
            flex: 1,
            // ...(Platform.OS === 'web' ? {
            width: '80%',
            alignSelf: 'center',
            // } : {}),
          }}
        >
          <CustomComponent userData={userData} />
        </ScrollView>
      </View>
    );
  }
}

PublisherMethod.defaultProps = {
  updateUserData: () => null,
};

PublisherMethod.propTypes = {
  userData: AORTypes.User.isRequired,
  match: ReactRouterPropTypes.match.isRequired,
  history: ReactRouterPropTypes.history.isRequired,
  onUpdateUser: PropTypes.func.isRequired,
  updateUserData: PropTypes.func, // can't be 'isRequired' because of 'skip'
};

export default PublisherMethod;
